import React from 'react';
import './App.css';
import {  Route, Router, Routes } from 'react-router-dom';
import Main from './Main/Main';
import OurExpertise from './OurExpertise/OurExpertise';
import AboutUs from './AboutUs/About';
import Question from './FA&Q/Questions';
import Help from './HowCanWeHelp/Help';
import Event from './Event/Event';
import ScrollToTop from './ScrollToTop';





function App() {
  return (
    <div className="App">
      <div>
      
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
         <Route path="/about" element={<OurExpertise />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/question" element={<Question />} /> 
        <Route path="/help" element={<Help />} /> 
         <Route path="/event" element={<Event />} /> 
      </Routes> 
       
    </div>
    
      
    </div>
  );
}

export default App;
